/* =========================================================================
   EP Nutrition – Desktop Header Helper
   Datei: assets/ep-desktop-header.js
   ========================================================================= */
(function () {
  'use strict';

  var isUpdating = false;

  /* ===== Header-Reihenfolge =====
     HINWEIS: Das DOM-Umsortieren wurde ENTFERNT, weil es beim Laden ein
     sichtbares Springen verursacht hat (HTML-Reihenfolge -> JS-Reihenfolge).
     Die Reihenfolge "Burger | Logo | Suche | Account/Cart" wird jetzt direkt
     per CSS (order) in header.liquid gesetzt und steht damit ab dem ersten
     Frame korrekt. Diese Funktion ist daher absichtlich leer. */
  function reorderHeader() {
    return;
  }

  /* ===== Sprachumschalter Toggle ===== */
  function initLocaleSwitcher() {
    var switcher = document.querySelector('.ep-locale-switcher');
    if (!switcher) return;
    if (switcher.dataset.epInit) return;
    switcher.dataset.epInit = '1';

    var toggle = switcher.querySelector('[data-ep-locale-toggle]');
    if (!toggle) return;

    toggle.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var isOpen = switcher.classList.contains('is-open');
      if (isOpen) {
        switcher.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
      } else {
        switcher.classList.add('is-open');
        toggle.setAttribute('aria-expanded', 'true');
      }
    });

    // Klick außerhalb schließt Dropdown
    document.addEventListener('click', function (e) {
      if (!switcher.contains(e.target)) {
        switcher.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
      }
    });

    // ESC schließt Dropdown
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        switcher.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
      }
    });
  }

  /* ===== Cart Counter Logik ===== */
  function cleanCounterText(counter) {
    if (!counter) return 0;
    var raw = (counter.textContent || '').trim();
    var match = raw.match(/\d+/);
    var num = match ? parseInt(match[0], 10) : 0;
    return isNaN(num) ? 0 : num;
  }

  function updateCartButtons() {
    if (isUpdating) return;
    isUpdating = true;

    try {
      var cartButtons = document.querySelectorAll(
        '.site-header a.button--solid.button--icon, ' +
        '.site-header a.mobile-cart-button'
      );

      cartButtons.forEach(function (btn) {
        var counter = btn.querySelector('[data-header-cart-count]');
        if (!counter) return;

        var num = cleanCounterText(counter);

        if (num > 0) {
          btn.setAttribute('data-cart-has-items', '');
          if (counter.textContent.trim() !== String(num)) {
            counter.textContent = String(num);
          }
          counter.classList.remove('element--wrap-paranth');
        } else {
          btn.removeAttribute('data-cart-has-items');
          counter.textContent = '';
        }
      });
    } finally {
      setTimeout(function () { isUpdating = false; }, 50);
    }
  }

  function init() {
    updateCartButtons();
    initLocaleSwitcher();

    var counters = document.querySelectorAll('[data-header-cart-count]');
    counters.forEach(function (counter) {
      var observer = new MutationObserver(function () {
        updateCartButtons();
      });
      observer.observe(counter, {
        childList: true,
        characterData: true,
        subtree: true
      });
    });

    document.addEventListener('cart:updated', updateCartButtons);
    document.addEventListener('cart:refresh', updateCartButtons);
    document.addEventListener('cart:open', updateCartButtons);

    var pollCount = 0;
    var pollInterval = setInterval(function () {
      updateCartButtons();
      initLocaleSwitcher();
      pollCount++;
      if (pollCount > 5) clearInterval(pollInterval);
    }, 2000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();